import React from 'react';

var DefaultContext = {
  color: undefined,
  size: undefined,
  className: undefined,
  style: undefined,
  attr: undefined
};
var IconContext = React.createContext && React.createContext(DefaultContext);

export { DefaultContext, IconContext };
//# sourceMappingURL=iconContext.js.map
